(() => {
  const kinds = [
    ['details', '.icon-price-tag', 'collapsible_tab_dqeniJ'],
    ['shipping', '.icon-plane', 'collapsible_tab_iXPBPW'],
    ['payment', '.icon-box', 'collapsible_tab_Dtn4WA'],
  ];

  const copyIcon = (kind) => {
    const template = document.getElementById(`custom-dh-pdp-icon-${kind}`);
    const svg = template?.content.querySelector('svg');
    return svg ? svg.cloneNode(true) : null;
  };

  const enhance = (container) => {
    container.querySelectorAll('.custom-pdp-drawer-trigger').forEach((trigger) => {
      const wrap = trigger.querySelector('.custom-pdp-drawer-trigger__icon');
      if (!wrap || wrap.dataset.customDhPdpIcon) return;
      const details = trigger.closest('.product__accordion')?.querySelector('details');
      const match = kinds.find(([, selector, block]) =>
        wrap.querySelector(selector) || details?.id.includes(block)
      );
      if (!match) return;
      const svg = copyIcon(match[0]);
      if (!svg) return;
      wrap.replaceChildren(svg);
      wrap.dataset.customDhPdpIcon = match[0];
      wrap.setAttribute('aria-hidden', 'true');
      trigger.querySelector('.custom-pdp-drawer-trigger__main')?.classList.add('custom-dh-pdp-icon-row');
    });

    container.querySelectorAll('.dh-shipping-note').forEach((note) => {
      if (note.querySelector(':scope > .custom-dh-pdp-shipping-icon')) return;
      const svg = copyIcon('shipping');
      if (!svg) return;
      const wrap = document.createElement('span');
      wrap.className = 'custom-dh-pdp-shipping-icon';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.appendChild(svg);
      note.prepend(wrap);
      note.classList.add('custom-dh-pdp-shipping-note');
    });
  };

  const observe = (container) => {
    if (container.dataset.customDhPdpIconsReady) return;
    container.dataset.customDhPdpIconsReady = 'true';
    let frame = 0;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        enhance(container);
      });
    };
    new MutationObserver(schedule).observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    enhance(container);
  };

  const init = () => {
    document.querySelectorAll('#MainContent .product__info-container').forEach(observe);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();
